import * as React from 'react';
import { translateReplace } from 'PyzShopUi/scripts/utils/translate';
import { IServicePageSearchResultItem } from '../../interfaces';

interface IServicePagesResultItemProps {
    servicePages: IServicePageSearchResultItem;
}

const ServicePagesResultItem: React.FunctionComponent<IServicePagesResultItemProps> = props => {
    const { servicePages } = props;

    return (
        <div className="service-pages-result-item">
            <a className="mobile-link hide-for-medium" href={servicePages.url}>
            </a>
            <h2>{servicePages.name}</h2>
            <p className="link">
                <a href={servicePages.url}>
                    <span dangerouslySetInnerHTML={{ __html: translateReplace('Go to {{title}};', { title: servicePages.name }, 'search') }} />
                </a>
            </p>
            <button className="next-button hide-for-medium">
                <i className="icon icon-chevron-thin-right icon-only icon-size-small" />
            </button>
        </div>
    )
};

export default ServicePagesResultItem;
